export * from './ProjectDetailsContainer';

export const PROJECT_DETAILS_TABS = {
  SUMMARY: "Summary",
  DATA_SOURCES: "Data Sources",
  SEARCH: "Search",
  ANALYZE: "Analyze",
};